import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=a34ad0fe&"
import script from "./sidebarMenu.vue?vue&type=script&lang=js&"
export * from "./sidebarMenu.vue?vue&type=script&lang=js&"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&id=a34ad0fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports